import { useEffect, useRef } from 'react';
import React from 'react';

import styled from '@emotion/styled';

import { getRecaptchaSiteKey, isRecaptchaEnabled } from '@utils/recaptcha';

const RecaptchaWidgetContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 12px 0;
`;

export const RecaptchaWidget: React.FC<{
  onChange?: (solved: boolean) => void;
}> = ({ onChange }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;
  const enabled = isRecaptchaEnabled();
  const siteKey = getRecaptchaSiteKey();

  useEffect(() => {
    if (!enabled || !siteKey) {
      onChangeRef.current?.(false);
      return;
    }
    if (typeof grecaptcha === 'undefined') return;

    grecaptcha.enterprise.ready(() => {
      if (!ref.current || ref.current.childNodes.length > 0) return;
      grecaptcha.enterprise.render(ref.current, {
        sitekey: siteKey,
        callback: () => onChangeRef.current?.(true),
        'expired-callback': () => onChangeRef.current?.(false),
        'error-callback': () => onChangeRef.current?.(false),
      });
    });
  }, [enabled, siteKey]);

  if (!enabled || !siteKey) return null;

  return (
    <RecaptchaWidgetContainer>
      <div ref={ref} />
    </RecaptchaWidgetContainer>
  );
};
